import React from "react";
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useGlobalData } from '../../context/globalDataContxt';
import ThemeProvider from "../../context/themeContext";
import { scriptSpecialCases } from '../../hooks/useScripts'
import { Header, HeaderHome, Footer, Seo } from "../index";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/theme.scss'
import './Layout.scss'

const Layout = ({ 
  children, 
  screenData,
  isHome = false, 
  pageMetadata = {},
  scriptSelect = [],
  footerData 
}) => {

  const { homeData } = useGlobalData();

  // const scriptSelect = [{
  //   enable: true,
  //   id: 1,
  //   name: "google-analytics",
  //   source: "//matomo.ucc.edu.ar/"
  // }]

  // const scripts = useScripts()
  const scripts = []
  const allScripts = [...scripts, ...scriptSelect];

  const renderedScripts = allScripts.map((script) =>
    script.enable === true ? (
      script.name.toLowerCase() === 'google-analytics' ||
      script.name.toLowerCase() === 'facebook-pixel' ||
      script.name.toLowerCase() === 'matomo-tag-manager' ||
      script.name.toLowerCase() === 'google-tag-manager' ? (
        scriptSpecialCases(script)
      ) : (
        <script
          src={script.source}
          type="text/javascript"
          name={script.name}
          siteId={script.siteId}
          key={script.id}
          async
        />
      )
    ) : null
  );

  return (
    <ThemeProvider>
      <Seo 
        title={pageMetadata.pageTitle} 
        description={pageMetadata.description} 
        keywords={pageMetadata.keywords}
      />
      
      {/* Header of the Screens */}
      {isHome ? (
        <HeaderHome screenData={screenData}/>
      ) : (
        <Header 
          screenData={screenData} 
          homeData={homeData}
        />
      )}
     
      {/* Helmet para scripts en todas las paginas */}
      {renderedScripts}

      {/* ThemaMinimal de SweetAlert */}
      <Helmet>
        <link
          href="//cdn.jsdelivr.net/npm/@sweetalert2/theme-minimal@4/minimal.css"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="@sweetalert2/themes/minimal/minimal.css"
        />
        <script
          src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
          integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
          crossOrigin="anonymous"
        ></script>
        <script
          src="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.bundle.min.js"
          integrity="sha384-Piv4xVNRyMGpqkS2by6br4gNJ7DXjqk09RmUpJ8jgGtD7zP9yug3goQfGII0yAns"
          crossOrigin="anonymous"
        ></script>
      </Helmet>

      <main className={`${!isHome ? 'main-custom' : ''} flex-grow-1 primary-background position-relative`}>{children}</main>
      
      <Footer footer={footerData}/>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  screenData: PropTypes.object.isRequired,
  logo: PropTypes.object,
  indexHeader: PropTypes.bool,
  header: PropTypes.object,
  scriptSelect: PropTypes.array
}

export default Layout;
